import { render, staticRenderFns } from "./VehicleActionsView.vue?vue&type=template&id=0b546c46&"
import script from "./VehicleActionsView.vue?vue&type=script&lang=ts&"
export * from "./VehicleActionsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports